import { Avatar, Box, Button, Flex, Text } from "@chakra-ui/react";

export const formatTableValue = (value, key) => {
  switch (key) {
    case "contact":
      const infos = value?.split("-") || [];
      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {infos?.length &&
            infos?.map((item, index) => <Text key={index}>{item}</Text>)}
        </Flex>
      );
    case "avatar":
      return <Avatar src={value} />;

    default:
      return <Text>{value}</Text>;
  }
};

export const formatTableValueV2 = (value, key, submit, id) => {
  switch (key) {
    case "avatar":
      return <Avatar src={value} />;
    default:
      return <Text>{value}</Text>;
  }
};